'use client'
import { ProductByEvent } from '@/features/product/model/product.model'
import { EventCard } from '../eventCard'

type Props = {
  events: ProductByEvent[]
}

export function EventGrid({ events }: Props) {
  if (!events.length) return null

  return (
    <>
      {events.map(event => (
        <EventCard
          key={event.id}
          title={event.name}
          products={event.products}
          eventId={event.id}
        />
      ))}
    </>
  )
}
